import { useLayoutEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useInView } from 'react-intersection-observer'
import kebabCase from 'lodash.kebabcase'

import { useCompanyDetails } from '@pepper/ui'

import { useSelectedCompanyId } from 'utils/functions/misc'
import useUserAccountType from 'utils/hooks/useUserAccountType'
import { VerticalOptions } from '../helper'
import styles from '../_.module.css'

import ServiceCard from './ServiceCard'

type ServiceListProps = {
  title: string
  verticals: VerticalOptions[]
  handleClick: (id: number) => void
  showTitle?: boolean
}

const ServicesList = ({
  title,
  verticals,
  showTitle = false,
  handleClick,
}: ServiceListProps): JSX.Element => {
  const key = kebabCase(title)
  const history = useHistory()
  const { ref, inView } = useInView({ threshold: 0.85, initialInView: true })
  const accountType = useUserAccountType()
  const companyId = useSelectedCompanyId()
  const { data: company } = useCompanyDetails(
    `/companies/${companyId}`,
    companyId
  )

  useLayoutEffect(() => {
    if (!inView) return

    history.push(`#${key}`)
  }, [history, inView, key, title])

  if (accountType === 'standard') {
    verticals = verticals.filter(item => item.isStandard === true)
  }

  if (!company?.all_verticals_access_flag) {
    verticals = verticals.filter(item => item.isRestricted)
  }
  return (
    <div ref={ref} id={key} className={styles.serviceListContainer}>
      {Array.isArray(verticals) && (verticals.length > 0 || showTitle) && (
        <>
          <h3 className={styles.listTitle}>{title}</h3>
          <div className={styles.serviceListWrapper}>
            {verticals.map(
              ({ icon_set, id, title: cardTitle, description }) => (
                <ServiceCard
                  handleClick={handleClick}
                  id={id}
                  icon={icon_set}
                  title={cardTitle}
                  description={description || ''}
                  key={`${title}-${id}`}
                />
              )
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default ServicesList
